<template>
  <tbody>
    <template v-for="(record, recordIndex) in tableData">
      <tr :key="getRowKey(recordIndex)">
        <td
          v-if="renderActionColumn"
          :class="[$style.inputTableCell, $style.tableCell]"
        >
          <label :class="$style.radioBtn">
            <input
              name="selectedRow"
              type="radio"
              @change="handleSelectItemClick(record.id, $event)"
            >
          </label>
        </td>
        <td
          v-for="(column, columnIndex) in columns"
          :key="columnIndex"
          :class="$style.tableCell"
        >
          <component
            :is="column.bodyComponent"
            v-if="column.bodyComponent"
            v-bind="getBodyComponentProps(column.bodyComponentProps, record)"
          />
          <span v-else>
            {{ getRecordValue(record, column) }}
          </span>
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { extend, values } from 'lodash';
import { mapActions } from 'vuex';
import TableMixin from 'components/Tables/TableMixin';

export default {
  name: 'TableBodyWithCustomComponents',

  mixins: [
    TableMixin,
  ],

  props: {
    itemType: {
      type: String,
      required: true,
      validator: function validator(value) {
        return values(ItemTypeConsts).indexOf(value) !== -1;
      },
    },
  },

  beforeCreate() {
    const { itemType } = this.$options.propsData;
    const storeModule = StoreModuleMap[itemType];

    extend(
      this.$options.methods,
      mapActions(storeModule, ['selectItem']),
    );
  },

  methods: {
    /**
      * @param {Object} bodyComponentProps - specific properties for the column
      * @param {Object} record - a row in the TableData
      *
      * @return {Object} [an object with all the properties {key:value} required by a component]
    */
    getBodyComponentProps(bodyComponentProps, record) {
      const props = Object.entries(bodyComponentProps).reduce((acc, [key, value]) => {
        if (typeof value === 'object') {
          const retVal = {};

          Object.keys(value).forEach(valueKey => {
            retVal[valueKey] = record[valueKey];
          });
          acc[key] = retVal;
        } else {
          acc[key] = record[value];
        }
        return acc;
      }, {});

      return props;
    },

    /**
      * @param {Object} record - a row in the TableData
      * @param {Object} column - a column in the Columns
      *
      * @return {String} [the value of each cell]
    */
    getRecordValue(record, column) {
      return record[column.dataField];
    },

    getRowKey(recordIndex) {
      return `row-${recordIndex}`;
    },

    handleSelectItemClick(id, $event) {
      const { checked } = $event.target;

      if (checked) {
        this.selectItem(id);
      }
    },
  },

};
</script>

<style scoped module>
@value (jcGrey200) from '~css/brand-colors.css';

.inputTableCell {
  width: 60px;
}

.radioBtn {
  margin: 0;
  padding: 0 0 0 20px;
}

.tableCell {
  border-bottom: 1px solid jcGrey200;
  padding: 10px !important;
}
</style>
